'use strict';

function Declined() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_AccountController, _Routes, _AnalyticsData];

  this.message = null;
  this.province = null;
  this.ageOfConsent = null;

  this._province = {
    AB: { name: 'Alberta', age: 18 },
    BC: { name: 'British Columbia', age: 19 },
    MB: { name: 'Manitoba', age: 18 },
    NB: { name: 'New Brunswick', age: 19 },
    NL: { name: 'Newfoundland & Labrador', age: 19 },
    NS: { name: 'Nova Scotia', age: 19 },
    NT: { name: 'Northwest Territories', age: 19 },
    NU: { name: 'Nunavut', age: 19 },
    ON: { name: 'Ontario', age: 18 },
    PE: { name: 'Prince Edward Island', age: 18 },
    QC: { name: 'Quebec', age: 18 },
    SK: { name: 'Saskatchewan', age: 18 },
    YT: { name: 'Yukon', age: 19 }
  };

  this.init = function () {
    this._super();
    this._nav = $('.portal__nav');
    this.message = $(this.node).attr('data-declined-message');
    this.province = this.presenter.models.account.province;
    this.ageOfConsent = this._getAgeOfConsent(this.province);

    // legacy user with missing profile info
    if (!this.hasAllProfileInfo() && (!this.presenter.models.account.province || !this.presenter.models.account.birth_date)) {
      this.routeToNextStep();
      return;
    }
    switch (this.message) {
      case 'underage':
        this.showDateToEligibility(this.ageOfConsent);
        break;
      case 'province':
        var formattedProvince = this.formatAbbreviatedProvince(this.province);
        $(this.node).find('#userProvince').html(formattedProvince);
        break;
      case 'province-underage':
        break;
      case 'account-already-exists':
        // Delete session as user no longer allowed in Portal.
        // Will disable timeout warning and redirect to login on page refresh
        if (this.presenter.models.account.existing_account_email_address) {
          $(this.node).find('.js-logOut').on('click', this._onLogout.bind(this));
          this.analytics.pushEvent('account-signup-uuid-match', {
            originalUUID: [this.presenter.models.account.existing_account_uuid],
            replicateUUID: [this.presenter.models.account.uuid]
          });
          // Avoid users going to dashboard in this state:
          this._nav.find('.logo a').on('click', this._onLogout.bind(this));
          this._session.deleteSession();
        }
        break;
      default:
        console.error(this.message + ' is not a valid decline message');
    }
  };

  this.initAllReady = function () {
    this._super();
    if (this.hasValidProvinceAge() && !this.presenter.getModelProperty('account.existing_account_email_address')) {
      this.routeToNextStep();
      return;
    }
    this.analytics.pushEvent('virtual-page-view');
  };

  this.showDateToEligibility = function () {
    var validBirthdate = this._getBirthdateOfEligibility(this.ageOfConsent);
    var userBirthdate = new Date(this.presenter.models.account.birth_date);
    var timeToEligibility = this._getTimeDifference(validBirthdate, userBirthdate);

    var days = this._formatDoubleDigit(timeToEligibility.years * 365 + timeToEligibility.days);
    var hours = this._formatDoubleDigit(timeToEligibility.hours);
    var minutes = this._formatDoubleDigit(timeToEligibility.minutes);

    $(this.node).find('#timeInDays').html(days);
    $(this.node).find('#timeInHours').html(hours);
    $(this.node).find('#timeInMinutes').html(minutes);
  };

  this._getBirthdateOfEligibility = function () {
    var validDate = new Date();
    validDate.setYear(validDate.getFullYear() - this.ageOfConsent);
    return validDate;
  };

  this._getTimeDifference = function (a, b) {
    var timeDifference = Math.abs(b.getTime() - a.getTime());
    var differenceInSeconds = Math.ceil(timeDifference / 1000);
    return this._convertSecondsToString(differenceInSeconds);
  };

  this._convertSecondsToString = function (seconds) {
    var years = Math.floor(seconds / 31536000);
    var days = Math.floor(seconds % 31536000 / 86400);
    var hours = Math.floor(seconds % 31536000 % 86400 / 3600);
    var minutes = Math.floor(seconds % 31536000 % 86400 % 3600 / 60);
    var second = seconds % 31536000 % 86400 % 3600 % 60;
    return { years: years, days: days, hours: hours, minutes: minutes, seconds: second };
  };

  this._formatDoubleDigit = function (number) {
    return (number < 10 ? '0' : '') + number;
  };

  this._getAgeOfConsent = function (province) {
    return this._province.hasOwnProperty(province) ? this._province[province].age : console.error(province + ' is not a valid province that Mogo operates in');
  };

  this.formatAbbreviatedProvince = function (province) {
    return this._province.hasOwnProperty(province) ? this._province[province].name : console.error(province + ' is not a valid province');
  };
}